var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore726569(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.971,
    height: 17.474,
    viewBox: "0 0 19.971 17.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "store_726569",
    transform: "translate(0 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182973",
    "data-name": "Group 182973",
    transform: "translate(0 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182972",
    "data-name": "Group 182972",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61766",
    "data-name": "Path 61766",
    d: "M19.952,37.466l-1.13-4.521A1.247,1.247,0,0,0,17.612,32H2.36a1.25,1.25,0,0,0-1.212.945L.019,37.466A.61.61,0,0,0,0,37.617a3.049,3.049,0,0,0,2.964,3.12A2.913,2.913,0,0,0,5.3,39.53a2.872,2.872,0,0,0,4.681,0,2.872,2.872,0,0,0,4.681,0,2.911,2.911,0,0,0,2.34,1.207,3.049,3.049,0,0,0,2.964-3.12A.61.61,0,0,0,19.952,37.466Z",
    transform: "translate(0 -32)",
    fill: "#7d96ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182975",
    "data-name": "Group 182975",
    transform: "translate(1.248 41.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182974",
    "data-name": "Group 182974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61767",
    "data-name": "Path 61767",
    d: "M47.758,269.918a4.084,4.084,0,0,1-2.34-.734,4.2,4.2,0,0,1-4.681,0,4.2,4.2,0,0,1-4.681,0A4.052,4.052,0,0,1,32,269.53v6.629a1.249,1.249,0,0,0,1.248,1.248h4.993v-4.993h4.993v4.993h4.993a1.249,1.249,0,0,0,1.248-1.248V269.53A4.05,4.05,0,0,1,47.758,269.918Z",
    transform: "translate(-32 -269.184)",
    fill: "#7d96ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore726569);
export default __webpack_public_path__ + "static/media/store_726569.10d0001b3c0c57f1540d0019c1dcf241.svg";
export { ForwardRef as ReactComponent };